import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import BannerRibbon from "../BannerRibbon";
import MetricCard from "../MetricCard";

const EducationMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("education data:", sortedMetrics);

    if (!indicators || indicators.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define metrics for order
    const e: DisaggregatedMetric[] = sortedMetrics[0];
    // const b = indicators?.find(i => i.id === 1239);
    // const nhs = indicators?.find(i => i.id === 1104);
    // const hs = indicators?.find(i => i.id === 1240);


    return (
        <div className="mx-auto px-4 pb-8 pt-4">
            <BannerRibbon text="Education"/>

            <div className="grid grid-cols-2 gap-4">
                {e?.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgrMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}
                {/* <div className="col-span-2 flex justify-center">
                    {hs && b && (
                    <DoubleMetricCard 
                        key={hs.id}
                        metricOne={hs}
                        metricTwo={b}
                        subtextOne="HS Diploma/GED+"
                        subtextTwo="Bachelor's Degree+"
                        title="Educational Attainment"
                        metadataId={1240}
                        width="w-full"
                        svg={getSvgrMap(hs.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                        showMetadataIcon={true}
                        showBothMetadataIcons={true}
                    />
                    )}
                </div> */}
            </div>
        </div>
    );
}

export default EducationMetrics;